import { useTranslation } from 'react-i18next';
import { Flex } from 'ui';
import { Text } from 'ui/typography';

type P = {
  endTime?: Date;
  startTime?: Date;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramDuration = ({ endTime, startTime }: P) => {
  const { t } = useTranslation();

  return (
    <Flex className="program-topbar__duration" vertical>
      <Text className="program-topbar__date">
        {t('dateFormats.shortMonthDayYear', {
          date: {
            end: endTime ? new Date(endTime) : undefined,
            start: startTime ? new Date(startTime) : undefined,
          },
        })}
      </Text>
    </Flex>
  );
};

export default ProgramDuration;
